import type { v2 } from '@sap/ux-specification-types';

export class ToolBar implements v2.ToolBar {
    actions: v2.Actions;
}
